import {Component, HostBinding, Input} from '@angular/core';

@Component({
    selector: 'vui-actions',
    templateUrl: './actions.component.html',
    styleUrls: ['./actions.component.scss']
})
export class ActionsComponent {
    @HostBinding('style.justify-content') @Input() public justify: string;
}
